import React from 'react'

interface Props {
  crop: {
    x: number
    y: number
    width: number
    height: number
  }
  onResizeStart: (e: React.MouseEvent<HTMLDivElement>, handle: string) => void
  onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void
  resizable?: boolean
}

const ImageCroppable: React.FC<Props> = (props) => {
  const { crop, onResizeStart, onMouseDown, resizable = true } = props
  return (
    <div
      className="absolute cursor-move border-2 border-white bg-black/15 shadow-[0_0_0_9999px_rgba(0,0,0,0.45)]"
      style={{
        left: `${crop.x}px`,
        top: `${crop.y}px`,
        width: `${crop.width}px`,
        height: `${crop.height}px`,
      }}
      onMouseDown={onMouseDown}
    >
      {resizable ? (
        <>
          <div
            className="absolute h-3 w-3 cursor-nwse-resize border-2 border-blue-500 bg-white"
            style={{ top: '-6px', left: '-6px' }}
            onMouseDown={(e) => onResizeStart(e, 'tl')}
          />
          <div
            className="absolute h-3 w-3 cursor-nesw-resize border-2 border-blue-500 bg-white"
            style={{ top: '-6px', right: '-6px' }}
            onMouseDown={(e) => onResizeStart(e, 'tr')}
          />
          <div
            className="absolute h-3 w-3 cursor-nesw-resize border-2 border-blue-500 bg-white"
            style={{ bottom: '-6px', left: '-6px' }}
            onMouseDown={(e) => onResizeStart(e, 'bl')}
          />
          <div
            className="absolute h-3 w-3 cursor-nwse-resize border-2 border-blue-500 bg-white"
            style={{ bottom: '-6px', right: '-6px' }}
            onMouseDown={(e) => onResizeStart(e, 'br')}
          />

          <div
            className="absolute h-3 cursor-ns-resize border-2 border-blue-500 bg-white"
            style={{
              top: '-6px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '20px',
            }}
            onMouseDown={(e) => onResizeStart(e, 't')}
          />
          <div
            className="absolute h-3 cursor-ns-resize border-2 border-blue-500 bg-white"
            style={{
              bottom: '-6px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '20px',
            }}
            onMouseDown={(e) => onResizeStart(e, 'b')}
          />
          <div
            className="absolute w-3 cursor-ew-resize border-2 border-blue-500 bg-white"
            style={{
              left: '-6px',
              top: '50%',
              transform: 'translateY(-50%)',
              height: '20px',
            }}
            onMouseDown={(e) => onResizeStart(e, 'l')}
          />
          <div
            className="absolute w-3 cursor-ew-resize border-2 border-blue-500 bg-white"
            style={{
              right: '-6px',
              top: '50%',
              transform: 'translateY(-50%)',
              height: '20px',
            }}
            onMouseDown={(e) => onResizeStart(e, 'r')}
          />
        </>
      ) : null}
    </div>
  )
}

export default ImageCroppable
